import React, { useEffect, useRef, useState } from "react";
import Skeleton from "v2/components/base/Skeleton/ui";

const TweetButton = ({ tgUserId }: { tgUserId: number | null }) => {
  const twitterShareButtonRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Initialize Twitter widgets if script is loaded
    if ((window as any).twttr && (window as any).twttr.widgets) {
      (window as any).twttr.widgets.load();
      setIsLoaded(true);
    }
  }, []);

  return (
    <a
      ref={twitterShareButtonRef}
      href="https://twitter.com/intent/tweet" // Use intent/tweet for reliability
      className="twitter-share-button"
      data-size="large"
      data-text="Join me at Cabal Town. Earn up to 50% of the fees from your trading cabals!"
      data-url={`https://app.cabal.town?referralId=${tgUserId}`}
      data-show-count="false"
      style={{ display: isLoaded ? "block" : "none" }}>
      Share
    </a>
  );
};

export default TweetButton;
